import React from 'react';
import InstitutionRevenue from '../../components/Accounts/InstitutionRevenue';

const InstitutionRevenuePage = () => {
  return (
    <div>
      <InstitutionRevenue />
    </div>
  );
};

export default InstitutionRevenuePage;
